import {list} from "@mc/mc-legacy";
import PolozkaApi from "../api/gen/cgo/PolozkaApi";

export const FAKTURACNI_POLOZKY_LIST_AREA = "fakturacniPolozkyList";
export const CENIKY_SPOLECNOST_LIST_AREA = "cenikySpolecnostList";
export const CENIKY_LIST_AREA = "cenikyList";
export const CENIK_POLOZKY_LIST_AREA = "cenikPolozkyList";
export const PAROVANI_POLOZKY_LIST_AREA = "parovaniPolozkyList";

/**
 * Načtení seznamu fakturačních položek.
 * @returns {Function}
 */
export function fetchFakturacniPolozkyIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(FAKTURACNI_POLOZKY_LIST_AREA, null, (parent, filter) => {
            return PolozkaApi.getPolozky(filter.fulltext ? filter.fulltext : null, filter.vcetneNeaktivnich ? true : null);
        }));
    }
}

/**
 * Filtrování fakturačních položek.
 * @param filter filtr
 * @returns {Function}
 */
export function filterPolozky(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(FAKTURACNI_POLOZKY_LIST_AREA, filter));
    }
}

/**
 * Zneplatnění seznamu fakturačních položek.
 * @returns {Function}
 */
export function invalidateFakturacniPolozky() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(FAKTURACNI_POLOZKY_LIST_AREA));
    }
}

/**
 * Načtení seznamu všech ceníků.
 * @returns {Function}
 */
export function fetchCenikyIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(CENIKY_LIST_AREA, null, (parent) => {
            return PolozkaApi.getCeniky(null, parent);
        }));
    }
}

/**
 * Zneplatnění seznamu ceníků společnosti.
 * @returns {Function}
 */
export function invalidateCeniky() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(CENIKY_LIST_AREA));
    }
}

/**
 * Načtení seznamu ceníků společnosti.
 * @param spolecnostId ID společnosti
 * @returns {Function}
 */
export function fetchCenikySpolecnostiIfNeeded(spolecnostId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(CENIKY_SPOLECNOST_LIST_AREA, spolecnostId, (parent) => {
            return PolozkaApi.getCeniky(null, parent);
        }));
    }
}

/**
 * Zneplatnění seznamu ceníků společnosti.
 * @returns {Function}
 */
export function invalidateCenikySpolecnosti() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(CENIKY_SPOLECNOST_LIST_AREA));
    }
}

/**
 * Načtení seznamu položek v ceníku.
 * @param cenikId ID ceníku
 * @returns {Function}
 */
export function fetchCenikPolozkyIfNeeded(cenikId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(CENIK_POLOZKY_LIST_AREA, cenikId, (parent) => {
            return PolozkaApi.getCenikPolozky(parent);
        }));
    }
}

/**
 * Zneplatnění položek ceníku.
 * @returns {Function}
 */
export function invalidateCenikPolozky() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(CENIK_POLOZKY_LIST_AREA));
    }
}

/**
 * Načtení seznamu párování fakturačních položek.
 * @returns {Function}
 */
export function fetchParovaniFakturacniPolozkyIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(PAROVANI_POLOZKY_LIST_AREA, null, () => {
            return PolozkaApi.getPolozkyParovani();
        }));
    }
}

/**
 * Zneplatnění seznamu párování fakturačních položek.
 * @returns {Function}
 */
export function invalidateParovaniFakturacniPolozky() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(PAROVANI_POLOZKY_LIST_AREA));
    }
}
